import axios from "axios";
import { auth } from "../firebase/authService";

const BASE_URL = process.env.REACT_APP_BASE_API_URL;

const getToken = async () => {
  const user = JSON.parse(localStorage.getItem("user"));
  return user?.token;
};

export const apiRequest = async (
  method,
  endpoint,
  data = null,
  customHeaders = {}
) => {
  const token = await getToken();

  const config = {
    method,
    url: `${BASE_URL}${endpoint}`,
    headers: {
      Authorization: `Bearer ${token}`,
      "x-api-key": process.env.REACT_APP_API_KEY,
      ...customHeaders,
    },
    data,
  };
  try {
    const response = await axios(config);
    return response.data;
  } catch (error) {
    if (
      error.response?.status === 401 &&
      error.response.data.message ===
        "Token has expired. Please refresh the token."
    ) {
      // Token expired, refresh it and retry the request
      const storedUser = JSON.parse(localStorage.getItem("user"));
      if (!storedUser) throw new Error("No user session found");
      // Refresh the token from Firebase
      if (auth.currentUser) {
        const newToken = await auth.currentUser.getIdToken(true);
        storedUser.token = newToken;
        storedUser.tokenExpiryTime = Date.now() + 3400 * 1000;

        localStorage.setItem("user", JSON.stringify(storedUser));

        // Retry the request with the new token
        config.headers.Authorization = `Bearer ${newToken}`;
        const retryResponse = await axios(config);
        return retryResponse.data;
      }
    } else if (error.response?.status === 403) {
      console.error("Unauthorized access, token may be invalid.");
    } else {
      console.error("API request error:", error.message);
    }

    throw new Error(
      error.response?.data.message || "An error occurred. Please try again."
    );
  }
};

// Modified the title of this property
// 66eaaa09c8af4a76392020b0

// "eyJhbGciOiJSUzI1NiIsImtpZCI6IjkyODg2OGRjNDRlYTZhOThjODhiMzkzZDM2NDQ1MTM2NWViYjMwZDgiLCJ0eXAiOiJKV1QifQ.eyJuYW1lIjoiTmF5ZWVtIEFoYW1tYWQiLCJpc3MiOiJodHRwczovL3NlY3VyZXRva2VuLmdvb2dsZS5jb20vaG91c2VzY2FuLWM5YjNiIiwiYXVkIjoiaG91c2VzY2FuLWM5YjNiIiwiYXV0aF90aW1lIjoxNzMyNDA1MDg1LCJ1c2VyX2lkIjoiOVR3U1hWenNDeWZyNmFBNDhuQk9MQVNveHh3MSIsInN1YiI6IjlUd1NYVnpzQ3lmcjZhQTQ4bkJPTEFTb3h4dzEiLCJpYXQiOjE3MzI0MDUwODgsImV4cCI6MTczMjQwODY4OCwiZW1haWwiOiJwcm9nLm5heWVlbUBnbWFpbC5jb20iLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwiZmlyZWJhc2UiOnsiaWRlbnRpdGllcyI6eyJlbWFpbCI6WyJwcm9nLm5heWVlbUBnbWFpbC5jb20iXX0sInNpZ25faW5fcHJvdmlkZXIiOiJwYXNzd29yZCJ9fQ.eQSHKGFCrI9Kf4NNcofdgqKT1p4OKjXfLfWzOsgP5n99xuHdL0umdPdEIcFbmQEXe2J_DGl4CTrTRGPuoSs3pf0M8nUuJ1MLDk5p1BWDcrX-COu4qJzk8BacfvGAp7usezOjVpTZ8iyifebR8S38Ev-7blLXLieKOaToRsaF1qtVo7ez9NU41totGrb0uQT1fL5xqUquE-KuOt9ILfHLIZSECCfTl5mPYrbKalwpArEQGypFsqc11cH4aAP2DcN2ERwsA0vxqW2UsxCYbn24cw0q9337mHz9VUzWuwtfE6ZVpmmS4eulgC6DSKISJttgO5Jn2QeRas1T43RE6S2UOg"
